const UnitList = () =>
  import(/* webpackChunkName: "ValidDomain" */ 'src/components/Dashboard/Views/Units/UnitList.vue');

const UnitEditAdditional = () =>
  import(/* webpackChunkName: "ValidDomain" */ 'src/components/Dashboard/Views/Units/UnitEditAdditional.vue');
const UnitPublicLinks = () =>
  import(/* webpackChunkName: "ValidDomain" */ 'src/components/Dashboard/Views/Units/UnitPublicLinks.vue');

export const unitRoutes = [
  {
    path: 'units/',
    name: 'Unit List',
    component: UnitList
  },
  {
    path: 'units/public-links',
    name: 'Unit Public Links',
    component: UnitPublicLinks,
  },
  {
    path: 'units/edit-additional/:unitId',
    name: 'Unit Edit Additional',
    component: UnitEditAdditional,
    props: (route) => ({
      unitId: parseInt(route.params.unitId),
    }),
  },
];
